import { isFeature } from '../Feature/Feature.js';
import { query } from '../Query/Query.js';

var get = function get(expression, ignoreModifier) {
  return (isFeature(expression) ? query(expression) : expression).get(ignoreModifier);
};
var toQueryString = function toQueryString(expressions, ignoreModifier) {
  if (Array.isArray(expressions)) {
    var string = '';
    for (var i = 0, n = expressions.length; i < n; i += 1) {
      if (i > 0) string += ', ';
      string += get(expressions[i], ignoreModifier);
    }
    return string;
  }
  return get(expressions, ignoreModifier);
};

export { toQueryString };
//# sourceMappingURL=toQueryString.js.map
